import { LoadingView } from 'components/partials/LoadingView'
import React from 'react'

import { useAuth } from 'hooks/useAuth'
import { useCurrentUser } from 'hooks/useCurrentUser'

interface Props {
  children: React.ReactNode
}

export const LoadingProvider = ({ children }: Props) => {
  const { data: authUser } = useAuth()
  const { isFetched } = useCurrentUser()

  if (authUser && !isFetched) {
    return <LoadingView />
  }

  return <>{children}</>
}
